module.exports = __webpack_public_path__ + "img/pruvo_icon.a456a015.png";